module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[63]62.bc4ac80.woff2";